const ACTIONS = {
	JOIN: "join",
	JOINED: "joined",
	DISCONNECTED: "disconnected",
	CODE_CHANGE: "code_change",
	SYNC_CODE: "sync_code",
	LEAVE: "leave",
};

module.exports = ACTIONS;
